// Synchronise with less variable @mobile-bottom-navigation-height
export const BOTTOM_NAVIGATION_HEIGHT = 56;
